module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 19
// module chunks = 0